import { render, staticRenderFns } from "./SkuInfoData.vue?vue&type=template&id=6c2398cc&scoped=true&"
import script from "./SkuInfoData.vue?vue&type=script&lang=js&"
export * from "./SkuInfoData.vue?vue&type=script&lang=js&"
import style0 from "./SkuInfoData.vue?vue&type=style&index=0&id=6c2398cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2398cc",
  null
  
)

export default component.exports